import { render, staticRenderFns } from "./FixedAlert.vue?vue&type=template&id=44c7fb33&scoped=true&"
import script from "./FixedAlert.vue?vue&type=script&lang=js&"
export * from "./FixedAlert.vue?vue&type=script&lang=js&"
import style0 from "./FixedAlert.vue?vue&type=style&index=0&id=44c7fb33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7fb33",
  null
  
)

export default component.exports